const MIN_CROP_SIZE = 8;
export {
  MIN_CROP_SIZE
};
//# sourceMappingURL=crop-constants.mjs.map
